import { InteractiveContainer } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { ReactComponent as JuglLogo } from "@web-src/modules/navigation/components/MainNavBar/components/SelectEntityPopover/assets/jugl-logo.svg";
import { ReactComponent as CXGradient } from "@web-src/modules/navigation/components/MainNavBar/components/SelectEntityPopover/assets/cx-gradient.svg";
import { ReactComponent as PMGradient } from "@web-src/modules/navigation/components/MainNavBar/components/SelectEntityPopover/assets/pm-gradient.svg";
import cxImage from "@web-src/modules/navigation/components/MainNavBar/components/SelectEntityPopover/assets/cx-image.png";
import pmImage from "@web-src/modules/navigation/components/MainNavBar/components/SelectEntityPopover/assets/pm-image.png";
import { SignUpFlowContentLayout } from "../../../components/SignUpFlowContentLayout/SignUpFlowContentLayout";

export const SelectProductStep: FC<{
  onSelectPM: () => void;
  onSelectCX: () => void;
}> = ({ onSelectPM, onSelectCX }) => {
  const { t } = useTranslations();

  return (
    <SignUpFlowContentLayout
      titleSectionClassName="w-full"
      title={
        <div className="pt-[24px] 2xl:pt-[80px]">
          {t({
            id: "select-product.title",
            defaultMessage: "Select Product",
          })}
        </div>
      }
      subtitle={t(
        {
          id: "select-product.info-bar",
          defaultMessage: "Visit {link} to know more about Jugl Products",
        },
        {
          link: (
            <a
              href="https://jugl.com"
              target="_blank"
              rel="noreferrer"
              className="text-primary-800 underline"
            >
              jugl.com
            </a>
          ),
        }
      )}
      description={
        <div className="flex w-full max-w-[514px] flex-col items-center gap-4">
          <InteractiveContainer
            className="relative flex w-full items-center overflow-hidden rounded-xl bg-dark py-6 pl-8"
            onClick={onSelectCX}
          >
            <CXGradient className="pointer-events-none absolute top-1/2 left-[100px] -translate-y-1/2" />
            <div className="relative z-[1] flex w-[250px] shrink-0 flex-col gap-4">
              <div className="flex flex-col gap-[3px]">
                <JuglLogo className="h-[18px] w-[38px]" />
                <span className="font-secondary text-[15px] font-semibold text-white">
                  {t({
                    id: "select-product.customer-experience",
                    defaultMessage: "Customer Experience",
                  })}
                </span>
              </div>
              <span className="font-secondary text-[13px] leading-[1.4] font-light text-dark-100">
                {t({
                  id: "select-product.cx-description",
                  defaultMessage:
                    "AI Agent driven tool for Sales and Customer Support",
                })}
              </span>
            </div>
            <img
              src={cxImage}
              alt=""
              className="pointer-events-none absolute top-1/2 right-0 h-[134px] -translate-y-1/2"
            />
          </InteractiveContainer>
          <InteractiveContainer
            className="relative flex w-full items-center overflow-hidden rounded-xl py-6 pl-8"
            style={{ backgroundColor: "#1045A1" }}
            onClick={onSelectPM}
          >
            <PMGradient className="pointer-events-none absolute top-1/2 left-[100px] -translate-y-1/2" />
            <div className="relative z-[1] flex w-[250px] shrink-0 flex-col gap-4">
              <div className="flex flex-col gap-[3px]">
                <JuglLogo className="h-[18px] w-[38px]" />
                <span className="font-secondary text-[15px] font-semibold text-white">
                  {t({
                    id: "select-product.project-management",
                    defaultMessage: "Project Management",
                  })}
                </span>
              </div>
              <span className="font-secondary text-[13px] leading-[1.4] font-light text-dark-100">
                {t({
                  id: "select-product.pm-description",
                  defaultMessage:
                    "AI driven tool for Project and Team management",
                })}
              </span>
            </div>
            <img
              src={pmImage}
              alt=""
              className="pointer-events-none absolute top-1/2 right-0 h-[134px] -translate-y-1/2"
            />
          </InteractiveContainer>
        </div>
      }
    />
  );
};
